export const googleAnalyticsConfig = {
	"trackingId": "UA-122648101-1"
};